<div
  *ngIf="isDatasetValid"
  class="spyline-chart">
  <canvas
    #chart
    class="spyline-chart__canvas"
    data-cy="spy-line-chart.canvas">
  </canvas>

  <coa-spy-line-chart-tooltip
    #tooltip
    [label]="label"
    [tooltip]="currentTooltip"
    class="spyline-chart__tooltip">
  </coa-spy-line-chart-tooltip>
</div>
